const sceneEnum = Object.freeze({
  LOYALTY: 'loyalty',
  ORDER: 'order',
  SCAN_RECEIPT: 'scanReceipt',
});

export default sceneEnum;
